<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <span
    class="inline-flex items-center gap-1 px-1.5 py-0.5 text-xs font-medium rounded-md shrink-0 text-white bg-[#F40009]"
  >
    <span class="i-lucide-ban size-3" />
    {{ t('CONTACTS_LAYOUT.DETAILS.BLOCKED_TAG') }}
  </span>
</template>
